import {useLexicalComposerContext} from '@lexical/react/LexicalComposerContext';
import {$insertNodes, $nodesOfType, COMMAND_PRIORITY_EDITOR, createCommand, $createParagraphNode, HISTORY_MERGE_TAG} from 'lexical';
import {useEffect} from 'react';
import {$createLoadingImageNode, LoadingImageNode} from '../nodes/loading-image-node';
import {$createImageNode} from '../nodes/image-node';

export const INSERT_UPLOADING_IMAGE_COMMAND = createCommand<{
    src: string;
    altText: string;
    fileId: string;
    originalName: string;
}>('INSERT_UPLOADING_IMAGE_COMMAND');

export const REPLACE_WITH_UPLOADED_IMAGE_COMMAND = createCommand<{
    tempFileId: string;
    fileId: string;
    newSrc: string;
}>('REPLACE_WITH_UPLOADED_IMAGE_COMMAND');

export default function ImageUploadPlugin() {
    const [editor] = useLexicalComposerContext();

    useEffect(() => {
        if (!editor.hasNodes([LoadingImageNode])) {
            throw new Error('ImageUploadPlugin: LoadingImageNode nie jest zarejestrowany w edytorze');
        }

        const unregisterInsert = editor.registerCommand(
            INSERT_UPLOADING_IMAGE_COMMAND,
            (payload) => {
                const {src, altText, fileId, originalName} = payload;

                editor.update(() => {
                    const loadingImageNode = $createLoadingImageNode({
                        src,
                        altText,
                        fileId,
                        originalName,
                    });
                    const emptyParagraph = $createParagraphNode();
                    $insertNodes([loadingImageNode, emptyParagraph]);
                });

                return true;
            },
            COMMAND_PRIORITY_EDITOR,
        );

        const unregisterUpdate = editor.registerCommand(
            REPLACE_WITH_UPLOADED_IMAGE_COMMAND,
            (payload) => {
                const {tempFileId,fileId, newSrc} = payload;

                editor.update(() => {
                    const nodes = $nodesOfType(LoadingImageNode);
                    for (const node of nodes) {
                        if (node.getFileId() === tempFileId) {
                            const imageData = node.convertToImageNode(fileId);
                            const imageNode = $createImageNode({...imageData, src: newSrc});
                            const emptyParagraph = $createParagraphNode();
                            node.replace(imageNode);
                            $insertNodes([emptyParagraph]);
                            break;
                        }
                    }
                }, {tag: HISTORY_MERGE_TAG});

                return true;
            },
            COMMAND_PRIORITY_EDITOR,
        );

        return () => {
            unregisterInsert();
            unregisterUpdate();
        };
    }, [editor]);

    return null;
}
